import { Box, Button, makeStyles, Menu, MenuItem, Typography } from '@material-ui/core';
import React from 'react';

import { LANGUAGES } from '../../../../config/languages';
import { useConfigContext } from '../../../../contexts/ConfigContext/ConfigContext';
import { Font } from '../Font';
import { LANGUAGE_PARAMS } from './constants/LanguageParams';
import { useLanguages } from './hooks/useLanguages';

export const LanguageSelector = () => {
  const {
    state: { language: currentLanguage },
  } = useConfigContext();

  const { setLanguageInApp } = useLanguages();

  const useStyles = makeStyles({
    root: {
      '& .MuiMenuItem-root': {
        minHeight: 0,
      },
    },
  });

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (language) => {
    if (language) {
      setLanguageInApp(language);
    }
    setAnchorEl(null);
  };

  const getLangParams = (language) => {
    if (!Object.keys(LANGUAGE_PARAMS).includes(language)) {
      return;
    }
    return LANGUAGE_PARAMS[language];
  };

  const classes = useStyles();

  if (!currentLanguage) {
    return null;
  }

  return (
    <>
      <Button onClick={handleMenuClick} style={{ marginLeft: '-4px' }}>
        <Box display={'flex'} alignItems={'center'}>
          <img
            src={`https://cdn.nemuru.com/assets/icons/countries/alpha_3/${getLangParams(currentLanguage)?.alpha_3}.svg`}
            style={{ height: 18, width: 18, paddingRight: '12px' }}
          />
          <Font variant="subtitle2" color={'textSecondary'}>
            {getLangParams(currentLanguage)?.label}
          </Font>
        </Box>
      </Button>
      <Menu
        className={classes.root}
        id="simple-menu"
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => handleClose(undefined)}
      >
        {Object.values(LANGUAGES).map((language) => (
          <MenuItem key={`language-selector-${language}`} onClick={() => handleClose(language)}>
            <Box display={'flex'} alignItems={'center'}>
              <img
                src={`https://cdn.nemuru.com/assets/icons/countries/alpha_3/${getLangParams(language)?.alpha_3}.svg`}
                style={{ height: 18, width: 18 }}
              />
              <Typography
                variant="subtitle2"
                color={'textSecondary'}
                style={{
                  paddingLeft: '8px',
                  fontWeight: language === currentLanguage ? '700' : '400',
                }}
              >
                {getLangParams(language)?.label}
              </Typography>
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
